import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFarmLivestock } from "services";

import { GET_FARM_LIVESTOCK, UPDATE_FARM_LIVESTOCK } from "consts";

export const useUpdateFarmLivestock = ({ farmId, year }: { farmId: string; year: number }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FARM_LIVESTOCK, farmId],
    mutationFn: updateFarmLivestock,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_LIVESTOCK, farmId, year] });
    },
  });
};
